const scene = "invoice/";
export const UPDATE_ORDERS = `${scene}UPDATE_ORDERS`;

